/** Persisted inbox thread list density (detailed vs dense). */
export const INBOX_DENSE_LAYOUT_STORAGE_KEY = 'flownotes_inbox_dense_layout'

/** Persisted inbox folders index: group rows by workspace. */
export const INBOX_GROUP_BY_WORKSPACE_STORAGE_KEY = 'flownotes_inbox_group_by_workspace'

export function readInboxDenseLayout(defaultDense = false): boolean {
  try {
    const stored = localStorage.getItem(INBOX_DENSE_LAYOUT_STORAGE_KEY)
    if (stored === 'true') return true
    if (stored === 'false') return false
  } catch {
    /* ignore */
  }
  return defaultDense
}

export function writeInboxDenseLayout(dense: boolean): void {
  try {
    localStorage.setItem(INBOX_DENSE_LAYOUT_STORAGE_KEY, dense ? 'true' : 'false')
  } catch {
    /* ignore */
  }
}

export function readInboxGroupByWorkspace(defaultGroup = true): boolean {
  try {
    const stored = localStorage.getItem(INBOX_GROUP_BY_WORKSPACE_STORAGE_KEY)
    if (stored === 'true') return true
    if (stored === 'false') return false
  } catch {
    /* ignore */
  }
  return defaultGroup
}

export function writeInboxGroupByWorkspace(group: boolean): void {
  try {
    localStorage.setItem(INBOX_GROUP_BY_WORKSPACE_STORAGE_KEY, group ? 'true' : 'false')
  } catch {
    /* ignore */
  }
}
